/* Header filter swatches mirror the native sidebar form and share its reload path. */
(function () {
  'use strict';
  if (window.PoletCollectionFilterWidgets) {
    window.PoletCollectionFilterWidgets.mount();
    return;
  }

  var active = null;
  function stop() {
    if (active) active.dispose();
    active = null;
  }
  function mount() {
    var container = document.getElementById('header-filters-container');
    if (active && active.container === container) return;
    stop();
    if (container) active = createWidgets(container);
  }
  window.PoletCollectionFilterWidgets = { mount: mount };
  document.addEventListener('collection:navigation:before', stop);
  document.addEventListener('collection:navigation:complete', mount);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    if (active && event.target.contains(active.container)) stop();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();

  function createWidgets(container) {
    var section = container.closest('[data-section-type="collection"]') || document;
    var disposed = false;
    var timers = new Set();
    var refreshTimer = null;
    var resizeTimer = null;
    var scrollTimer = null;
    var listeners = [];

    function connected() { return !disposed && container.isConnected; }
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(function () { target.removeEventListener(type, handler, options); });
    }
    function cancelTimer(id) {
      clearTimeout(id);
      timers.delete(id);
    }
    function delay(callback, ms) {
      var id = setTimeout(function () {
        timers.delete(id);
        if (connected()) callback();
      }, ms);
      timers.add(id);
      return id;
    }
    function sidebarForm() { return section.querySelector('#desktop-filters-form'); }
    function checkboxes() { return Array.from(container.querySelectorAll('.filter-checkbox')); }
    function labelFor(checkbox) {
      var label = checkbox.nextElementSibling;
      return label && label.classList.contains('block-swatch__item') ? label : null;
    }
    function updateLabel(checkbox) {
      var label = labelFor(checkbox);
      if (label) label.classList.toggle('checked', checkbox.checked);
    }

    function priority(text) {
      var lower = text.toLowerCase();
      if (lower.includes('mm')) return lower.includes('x') ? 2 : 1;
      if (lower.includes('col')) return 3;
      if (lower.includes('garnitura')) return 4;
      return 5;
    }
    function numeric(text) {
      var match = text.match(/([0-9]+(?:\.[0-9]+)?)/);
      return match ? parseFloat(match[1]) : Infinity;
    }
    function sortFilters() {
      container.querySelectorAll('.filter-content-inner').forEach(function (content) {
        var swatches = Array.from(content.querySelectorAll('.block-swatch')).map(function (swatch) {
          var label = swatch.querySelector('.block-swatch__item, .collection__filter-checkbox-disabled');
          var text = label ? label.textContent : '';
          return { element: swatch, priority: priority(text), numeric: numeric(text) };
        });
        swatches.sort(function (a, b) { return a.priority - b.priority || a.numeric - b.numeric; });
        var fragment = document.createDocumentFragment();
        swatches.forEach(function (item) { fragment.appendChild(item.element); });
        content.appendChild(fragment);
      });
    }
    function sizeButtons() {
      container.querySelectorAll('.filter-content-inner').forEach(function (content) {
        var wrapper = content.parentElement.querySelector('.show-more-container');
        var button = wrapper && wrapper.querySelector('.show-more-button');
        if (!button) return;
        var expanded = content.classList.contains('expanded');
        var maxHeight = parseInt(window.getComputedStyle(content).maxHeight, 10);
        var hasMore = expanded || content.scrollHeight > maxHeight;
        wrapper.classList.toggle('is-hidden', !hasMore);
        button.classList.toggle('is-visible', hasMore);
        content.classList.toggle('has-more', hasMore && !expanded);
        button.setAttribute('aria-expanded', String(expanded));
      });
    }
    function syncFromSidebar() {
      var form = sidebarForm();
      if (!form) return;
      var selected = new Set();
      form.querySelectorAll('input[type="checkbox"][name^="filter."]:checked').forEach(function (checkbox) {
        selected.add(checkbox.name + '=' + checkbox.value);
      });
      checkboxes().forEach(function (checkbox) {
        checkbox.checked = selected.has(checkbox.name + '=' + checkbox.value);
        updateLabel(checkbox);
      });
    }
    function refresh() {
      if (!connected()) return;
      syncFromSidebar();
      sortFilters();
      sizeButtons();
    }
    function scheduleRefresh() {
      cancelTimer(refreshTimer);
      refreshTimer = delay(refresh, 100);
    }
    function triggerFilterReload(checkbox) {
      var form = sidebarForm();
      if (!form) {
        window.location.href = window.location.href;
        return;
      }
      // Update only the selected swatch. Bulk copying would restore old values
      // when the customer clicks another swatch during a pending "clear all".
      var matching = Array.from(form.querySelectorAll('input[type="checkbox"]')).find(function (input) {
        return input.name === checkbox.name && input.value === checkbox.value;
      });
      if (matching) {
        matching.checked = checkbox.checked;
        matching.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var params = new URLSearchParams();
        var sortBy = container.getAttribute('data-sort-by');
        if (sortBy) params.set('sort_by', sortBy);
        checkboxes().forEach(function (input) { if (input.checked) params.append(input.name, input.value); });
        window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      }
      cancelTimer(scrollTimer);
      scrollTimer = delay(function () {
        var products = section.querySelector('#infinitypagination');
        if (products) products.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    listen(container, 'click', function (event) {
      var button = event.target.closest('.show-more-button');
      if (button && container.contains(button)) {
        event.preventDefault();
        event.stopPropagation();
        var wrapper = button.closest('.filter-wrapper');
        var content = wrapper && wrapper.querySelector('.filter-content-inner');
        if (content) {
          var expanded = !content.classList.contains('expanded');
          content.classList.toggle('expanded', expanded);
          content.classList.toggle('has-more', !expanded);
          button.classList.toggle('expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          var text = button.querySelector('.button-text');
          if (text) text.textContent = expanded ? 'Prikaži manj' : 'Prikaži več';
        }
        return;
      }
      var label = event.target.closest('label.block-swatch__item');
      if (label && container.contains(label)) {
        event.preventDefault();
        event.stopPropagation();
        var checkbox = checkboxes().find(function (input) { return input.id === label.getAttribute('for'); });
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = !checkbox.checked;
          updateLabel(checkbox);
          triggerFilterReload(checkbox);
        }
        return;
      }
      var clear = event.target.closest('[data-action="clear-filters"]');
      if (clear && container.contains(clear)) {
        event.preventDefault();
        event.stopPropagation();
        var url = clear.getAttribute('data-url');
        if (url) window.location.href = url;
      }
    });
    // Keyboard changes must use the sidebar form too: the header is not a form.
    listen(container, 'change', function (event) {
      if (!event.target.matches('.filter-checkbox')) return;
      event.stopPropagation();
      updateLabel(event.target);
      triggerFilterReload(event.target);
    });
    listen(document, 'click', function (event) {
      var clear = event.target.closest('[data-action="clear-filters"]');
      if (!clear || !section.contains(clear)) return;
      checkboxes().forEach(function (checkbox) { checkbox.checked = false; updateLabel(checkbox); });
      var form = sidebarForm();
      if (form) form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (checkbox) { checkbox.checked = false; });
    }, true);
    listen(document, 'theme:loading:end', scheduleRefresh);
    listen(document, 'filter:updated', scheduleRefresh);
    listen(window, 'resize', function () {
      cancelTimer(resizeTimer);
      resizeTimer = delay(sizeButtons, 250);
    }, { passive: true });
    refresh();

    return { container: container, dispose: function () {
      disposed = true;
      timers.forEach(clearTimeout);
      timers.clear();
      listeners.forEach(function (remove) { remove(); });
      listeners = [];
    } };
  }
})();
